function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* Copyright (C) 2018 TeselaGen Biotechnology, Inc. */
import React from "react";
import { Button, Popover, Position } from "@blueprintjs/core";
import classnames from "classnames";
import popoverOverflowModifiers from "./utils/popoverOverflowModifiers";

function DropdownButton(_ref) {
  var disabled = _ref.disabled,
      menu = _ref.menu,
      noRightIcon = _ref.noRightIcon,
      className = _ref.className,
      rest = _objectWithoutPropertiesLoose(_ref, ["disabled", "menu", "noRightIcon", "className"]);

  return /*#__PURE__*/React.createElement(Popover, {
    minimal: true,
    modifiers: popoverOverflowModifiers,
    disabled: disabled,
    autoFocus: false,
    content: menu,
    position: Position.BOTTOM_LEFT
  }, /*#__PURE__*/React.createElement(Button, _extends({}, rest, {
    disabled: disabled,
    className: classnames(className, "dropdown-button"),
    rightIcon: noRightIcon ? undefined : "caret-down"
  })));
}

export default DropdownButton;